<template>
    <div class="table-filter-one flex flex-left-center">
        <div class="filter-item">
            <span class="filter-item-title clock-icon">时间范围:</span>
            <a-date-picker class="at-select" v-model="where.start_date" valueFormat="YYYY-MM-DD"
                           @change="changed"></a-date-picker>
            <span class="delimiter"> - </span>
            <a-date-picker class="at-select" v-model="where.end_date" valueFormat="YYYY-MM-DD"
                           @change="changed"></a-date-picker>
        </div>
        <div class="filter-item" v-if="!hideMemberLevel">
            <span class="filter-item-title member-icon">会员等级:</span>
            <a-select class="at-select"
                      v-model="where.level_id"
                      width="120px"
                      :options="memberLevelOptions"
                      @dropdownVisibleChange="getMemberLevels"
                      allowClear
                      @change="changed"></a-select>
        </div>
        <div class="filter-item">
            <span class="filter-item-title search-icon">搜索:</span>
            <at-input v-model="where.keywords" width="175px" placeholder="请输入想要搜索的内容"></at-input>
            <button @click="changed" class="btn">搜索</button>
        </div>
    </div>
</template>
<script>
import AtInput from "@/components/AtInput.vue";
import api from "@/repo/api";

export default {
    name: "TableFilterOne",
    components: {AtInput},
    props: {
        query: {
            type: Object,
            default: () => {
            }
        },
        hideMemberLevel: {
            type: Boolean,
            default: false
        }
    },
    model: {
        prop: 'query',
        event: 'change'
    },
    data() {
        return {
            where: {
                keywords: '',
                level_id: '',
                start_date: '',
                end_date: ''
            },
            memberLevels: []
        }
    },
    watch: {
        query: {
            async handler(newVal) {
                
                const queryData = {...(newVal || {})};
                
                if (queryData.level_id) {
                    queryData.level_id = Number(queryData.level_id);
                    await this.getMemberLevels()
                }
                
                this.where = queryData;
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        memberLevelOptions() {
            return this.memberLevels.map(item => ({
                label: item.name,
                value: item.id
            }))
        }
    },
    methods: {
        changed() {
            
            this.$emit('change', this.where);
        },
        async getMemberLevels() {
            
            if (this.memberLevels.length) return;
            
            const data = await api.get('/ast-app/member-levels', {all: 1});
            
            this.memberLevels = data.data.length ? data.data : []
        }
    }
}
</script>
<style lang="less" scoped>
.table-filter-one {
    min-width: 950px;
    margin-bottom: 16px;
}

.filter-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-right: 32px;
    
    &:last-child {
        margin-right: 0;
    }
}

.filter-item-title {
    display: inline-block;
    padding-left: 26px;
    position: relative;
    margin-right: 8px;
    
    &::before {
        content: " ";
        width: 24px;
        height: 24px;
        position: absolute;
        left: 0;
        top: -2px;
        background-size: 100%;
    }
}

.clock-icon {
    &::before {
        background-image: url("/assets/icons/clock.png");
    }
}

.search-icon {
    &::before {
        background-image: url("/assets/icons/search.png");
    }
}

.member-icon {
    &::before {
        background-image: url("/assets/icons/level.png");
    }
}

.btn {
    margin-left: 8px;
    height: 40px;
}

.at-select {
    width: 120px;
}

.delimiter {
    display: inline-block;
    margin-left: 8px;
    margin-right: 8px;
}
</style>